import * as React from 'react';
import { ErrorWrapper } from '../../ErrorWrapper';
import { fairPlayIcon } from '../../../icons';

export const Loader = () => {
  return (
    <ErrorWrapper loading icon={fairPlayIcon}>
      Выполняем запрос...
    </ErrorWrapper>
  );
};
